import { Observable } from "rxjs";
import { AddressDto, AddressListGetQueryResult, AddressSetCommandResult, CountryListGetQueryResult } from "../../INTEGRA_Shop_Client";
import { InjectionToken } from "@angular/core";

export abstract class IAddressService {

  abstract countryListGet(filterDuplicatesByCountryCode?: boolean | undefined): Observable<CountryListGetQueryResult>;

  abstract addressListGet(): Observable<AddressListGetQueryResult>;

  abstract addressSet(address?: AddressDto | undefined): Observable<AddressSetCommandResult>;

  abstract addressDelete(address?: AddressDto | undefined): Observable<boolean>;
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IAddressServiceToken = new InjectionToken<IAddressService>('IAddressServiceToken');
